.group {
  &.group--small > *:not(:first-child) {
    margin-inline-start: calc(-1 * var(--rc-theme-spacing-xxs));
  }
}
